import { App } from 'vue'
import VueSocialSharing from 'vue-social-sharing'

export default {
  install(app: App<Element>): any {
    app.use(VueSocialSharing)
  }
}
